import {
  indiaVsNewzealandContestByCategoryList,
  saVsEngContestByCategoryList,
  wiWVsIndWT20ContestByCategoryList
} from '../fantasy_cricket/fantasy_cricket_contestbycategory';
import {
  saVsEngLeaderBoardData,
  wiWVsIndWLeaderBoardData
} from '../fantasy_cricket/fantasy_cricket_leaderboard';
import {
  indVsNzT20Match,
  indVsSaT20Match,
  indVsZimMatch,
  nzVsPakMatch,
  saVsEngOdiMatch,
  slVsAfgT20Match,
  wiWVsIndWT20Match
} from '../fantasy_cricket/fantasy_cricket_matches';
import {
  indVsSaT20MyContestList,
  indVsZimMyContestList,
  pakVsNzMyContestList,
  slVsAfgT20MyContestList
} from '../fantasy_cricket/fantasy_cricket_myContestList';
import {
  indWVsIreWMyAnswersList,
  indWVsNzWMyAnswersList,
  kolVsLsgAnswersList,
  punVsDcAnswersList
} from './fantasy-yes-no-answerslist';
import {
  indVsSaYesNoLeaderBoardData,
  indVsZimYesNoLeaderBoardData,
  indWVsIreWLeaderboardData,
  kolVsLsgLeaderboardData,
  nzVsPakYesNoLeaderBoardData,
  punVsDcLeaderBoardData,
  slVsAfgYesNoLeaderBoardData
} from './fantasy-yes-no-leaderboard';
import {
  // indWVsIreWMyContestList,
  kolVsLsgMyContestList,
  punVsDcMyCOntestList
} from './fantasy-yes-no-my-contest';
import {
  indVsSaYesNoMyTeamsList,
  indVsZimYesNoMyTeamsList,
  kolVsLsgMyTeamsList,
  nzVsPakYesNoMyTeamsList,
  punVsDcMyTeamsList,
  slVsAfgYesNoMyTeamList
} from './fantasy-yes-no-myteamlist';
import {
  indVsSaQuestionsList,
  indVsZimQuestionsList,
  indWVsIreWQuestionsList,
  indWVsWiWQuestionsList,
  kolVsLsgQuestionsList,
  pakVsNzQuestionsList,
  punVsDcQuestionsList,
  saVsEngQuestionsList,
  slVsAfgQuestionsList
} from './fantasy-yes-no-questions';
import { indWVsIreWContestListByCategory } from './fantays-yes-no-contest-category';
import { indWVsIreW, kolVsLsg, punVsDc } from './fantays-yes-no-matches';

export const fantasyYesNoFixtureMatchList = [
  indWVsIreW,
  indVsNzT20Match,
  wiWVsIndWT20Match,
  saVsEngOdiMatch
];
export const fantasyYesNoLiveMatchList = [punVsDc, nzVsPakMatch, indVsZimMatch];
export const fantasyYesNoResultMatchList = [kolVsLsg, slVsAfgT20Match, indVsSaT20Match];

export const fantasyYesNoQuestionsList = {
  '63f0d1accd82c2527e625fe8': indWVsIreWQuestionsList,
  '628240bd6d0713b9cf82d75c': kolVsLsgQuestionsList,
  '627fbf7d6d0713b9cf388229': punVsDcQuestionsList,
  '63cc017596851a4d7f92dbc2': indWVsWiWQuestionsList,
  '63be86840901e17d0f43117e': pakVsNzQuestionsList,
  '62fdf2711f7aacc4e352a767': indVsZimQuestionsList,
  '63d0d9c596851a4d7f67dcd5': saVsEngQuestionsList,
  '630727157e2d41535f39f628': slVsAfgQuestionsList,
  '63344fdc258445b807480bf7': indVsSaQuestionsList
};
export const fantasyYesnoContestListByCategory = {
  '63f0d1accd82c2527e625fe8': indWVsIreWContestListByCategory,
  '63cf79bd96851a4d7f28b245': indiaVsNewzealandContestByCategoryList,
  '63cc017596851a4d7f92dbc2': wiWVsIndWT20ContestByCategoryList,
  '63d0d9c596851a4d7f67dcd5': saVsEngContestByCategoryList
};

export const fantasyYesNoMyContestList = {
  '628240bd6d0713b9cf82d75c': kolVsLsgMyContestList,
  '627fbf7d6d0713b9cf388229': punVsDcMyCOntestList,
  '63be86840901e17d0f43117e': pakVsNzMyContestList,
  '62fdf2711f7aacc4e352a767': indVsZimMyContestList,
  '630727157e2d41535f39f628': slVsAfgT20MyContestList,
  '63344fdc258445b807480bf7': indVsSaT20MyContestList
};
export const fantasyYesNoMyAnswersList = {
  '63f0d1accd82c2527e625fe8': indWVsIreWMyAnswersList,
  '628240bd6d0713b9cf82d75c': kolVsLsgAnswersList,
  '627fbf7d6d0713b9cf388229': punVsDcAnswersList,
  '63cf79bd96851a4d7f28b245': indWVsNzWMyAnswersList
};

export const fantasyYesNoLeaderBoard = {
  '63f0d1accd82c2527e625fe8': indWVsIreWLeaderboardData,
  '628240bd6d0713b9cf82d75c': kolVsLsgLeaderboardData,
  '627fbf7d6d0713b9cf388229': punVsDcLeaderBoardData,
  '63cf79bd96851a4d7f28b245': indWVsIreWLeaderboardData,
  '63be86840901e17d0f43117e': nzVsPakYesNoLeaderBoardData,
  '62fdf2711f7aacc4e352a767': indVsZimYesNoLeaderBoardData,
  '63cc017596851a4d7f92dbc2': wiWVsIndWLeaderBoardData,
  '63d0d9c596851a4d7f67dcd5': saVsEngLeaderBoardData,
  '630727157e2d41535f39f628': slVsAfgYesNoLeaderBoardData,
  '63344fdc258445b807480bf7': indVsSaYesNoLeaderBoardData
};

export const fantasyYesNoMyTeamsList = {
  '628240bd6d0713b9cf82d75c': kolVsLsgMyTeamsList,
  '627fbf7d6d0713b9cf388229': punVsDcMyTeamsList,
  '63be86840901e17d0f43117e': nzVsPakYesNoMyTeamsList,
  '62fdf2711f7aacc4e352a767': indVsZimYesNoMyTeamsList,
  '630727157e2d41535f39f628': slVsAfgYesNoMyTeamList,
  '63344fdc258445b807480bf7': indVsSaYesNoMyTeamsList
};
